import { DatabaseProduct, DatabaseVariant } from "../../Api/Database";
import { useEffect, useState } from "react";

import MuiAccordion, { AccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary from "@mui/material/AccordionSummary";
import MuiAccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import config from "../../Api/config";
import VariantAccordion from "./VariantAccordion";
import useLazyLoader from "../../Api/lazyLoading";
import { useSession } from "../sessionProvider";
import { toast } from "react-toastify";
import DndList from "../dragNDropList";
import { DraggableProvidedDragHandleProps } from "react-beautiful-dnd";


const Accordion = styled((props: AccordionProps) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
  ))(({ theme }) => ({
    border: `2px solid rgba(0, 0, 0, 0.03)`,
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: "2px solid rgba(0, 0, 0, 0.03)",
}));

export interface ProductAccordionProps {
    product: DatabaseProduct
    delete: () => Promise<boolean>
}

export default function ProductAccordion(props: ProductAccordionProps) {

    const navigate = useNavigate();
    const [expanded, setExpanded] = useState(false);
    const [variants, setVariants] = useState<DatabaseVariant[]>([]);
    const notifyError = (err:any) => toast.error(err,{theme:"colored"});
    const {ownerId} = useSession();
    const {lazyLoadingRef, elements, end, loading, deleteElement} = useLazyLoader<DatabaseVariant, HTMLDivElement>({elementFetcher: (offset: string, limit: string) => {
        return config.API.getVariantList(ownerId, limit, offset)
    }})

    const handleChange = () => () => {
        setExpanded(!expanded);
    };

    useEffect(() => {
        // get variants
        if(props.product.id != undefined){
            config.API.getVariantList( props.product.id, "","").then((el) => {
                setVariants(el.results);
            }).catch(error => {
                console.error("Error in get variant list API: ", error);
                notifyError("Error in get variant list API: " + error);
            });
        }
    }, [])

    return (
        <Accordion
            expanded={expanded}
            onChange={handleChange()}
            key={"credential_info_" + props.product.id}
            sx={{ width: "100%" , marginTop:"10px"}}
            id={"credential_info_" + props.product.id}
        >
            <MuiAccordionSummary
            expandIcon={<ExpandMoreIcon />}
            sx={{ minHeight: "38px" }}
            >
            <Typography sx={{ fontSize: "16px", fontWeight: "550" }}>
                {props.product.title}
            </Typography>
            </MuiAccordionSummary>
            <AccordionDetails>
            <div className="product-details"> 
                
                <h2 className="sub-title">FAMILY PRODUCT ID: </h2> <p>{props.product.id}</p>
                <h2 className="sub-title">FAMILY PRODUCT NAME: </h2> <p>{props.product.title}</p>
                <h2 className="sub-title">FAMILY PRODUCT DESCRIPTION: </h2> <p>{props.product.description}</p>
                <h2 className="sub-title">PRODUCT 'THANK YOU' VIDEO: </h2> 
                {props.product.video_url !== "" ? <p>{props.product.video_url}</p>:<p>N/A</p>}
                <h2 className="sub-title">THUMBNAIL: </h2>
                <img src={props.product.thumbnail} alt={props.product.title} height="auto" width="120px"     
                    onError={({ currentTarget }) => {
                    currentTarget.onerror = null; // prevents looping
                    currentTarget.src="../img/no-img.png";
                    }}/>
            </div>
            <div>
                <button className="form_btn" onClick={() => {
                    props.delete().then(deleted => {
                        if(deleted) {
                            setExpanded(false);
                            document.getElementById("credential_info_" + props.product.id)?.remove();
                        }
                    })
                }}>Delete</button>

                <button className="form_btn" onClick={() => {
                    navigate('/edit/product/' + props.product.id);
                }}>Edit</button>

                <button className="form_btn" onClick={() => {navigate("/register/variant/"+props.product.id)}}>Create variants</button>

            </div>


            <div  className=" variant-details" ref={lazyLoadingRef} key={ props.product.id+"_x"}>
                {variants.length > 0 && <>
                    <h2 style={{fontSize: "14px", fontWeight: "bold"}}>PRODUCT VARIANTS: <span id={"saved_order"+props.product.id} className="awards_span hide">Saved new variant order</span></h2>
                    
                    <div >

                        <DndList id={props.product.id ?? 'id'} list={variants} onChange={(newVariants: any[]) => {
                            //todo: api klic, da spremeni stvari
                            config.API.editVariantOrder(newVariants.map((val, index) => {
                                return {id: val.id, order_number: index}
                            })).then((ok) => {
                                if(ok) {
                                    console.log("saved to database successfully");
                                    // Feedback something happned
                                    var div2 = document.getElementById("saved_order"+props.product.id);
                                    if(div2 !== null){
                                        div2.className="show";
                                        setTimeout(function() {
                                            if(div2 !== null){
                                                div2.className="hide";
                                            }
                                        }, 3000);
                                    }
                                }
                            })
                            setVariants(newVariants);
                        }}>{(value: any, index: number, props?: DraggableProvidedDragHandleProps) => {
                            return (
                                <VariantAccordion key={"variant"+index} data={value} dragAndDropIconProps={props} />
                            )
                        }}</DndList>

                    </div>
                </>}

            </div>
            </AccordionDetails>
        </Accordion>
    )
}
